<script>

	import { toast } from "bulma-toast"
	import { usersStore, userStore } from "../stores"

    import FacturamaService from '../$services/facturama.services'

	import ZipcodeColonyComponent from '../locations/component.zipcode.colony.svelte'

	import Form from '../$components/form.svelte'
	import InputText from '../$components/input.text.svelte'
	import Button from '../$components/button.svelte'
	import Select from '../$components/select.svelte'

    let loading = false
    const data = {location: {}}

     
	async function createClient() {

        data.userId = $userStore._id

		loading = true
		const resp = await FacturamaService.createClient(data)
		loading = false

		if(!resp.success)
			toast({message: resp.error.message, type: "is-danger" })

        usersStore.replace(resp.data)
        userStore.set(resp.data)
	}

</script>

<Form on:submit={createClient} { loading } >
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.name} label="Nombre" placeholder="Nombre" />
		</div>
		<div class="column">
			<InputText bind:value={data.rfc} label="RFC" placeholder="RFC" />
		</div>
	</div>
	<div class="columns">
		<div class="column">
			<Select bind:value={ data.fiscalRegime } 
				label="Régimen fiscal"
				options={[
					{value: '601', text: 'General de Ley Personas Morales'},
					{value: '603', text: 'Personas Morales con Fines no Lucrativos'},
					{value: '605', text: 'Sueldos y Salarios e Ingresos Asimilados a Salarios'},
					{value: '606', text: 'Arrendamiento'},
					{value: '607', text: 'Régimen de Enajenación o Adquisición de Bienes'},
					{value: '608', text: 'Demás ingresos'},
					{value: '609', text: 'Consolidación'},
					{value: '610', text: 'Residentes en el Extranjero sin Establecimiento Permanente en México'},
					{value: '611', text: 'Ingresos por Dividendos (socios y accionistas)'},
					{value: '612', text: 'Personas Físicas con Actividades Empresariales y Profesionales'},
					{value: '614', text: 'Ingresos por intereses'},
					{value: '615', text: 'Régimen de los ingresos por obtención de premios'},
					{value: '616', text: 'Sin obligaciones fiscales'},
					{value: '620', text: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos'},
					{value: '621', text: 'Incorporación Fiscal'},
					{value: '622', text: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras'},
					{value: '623', text: 'Opcional para Grupos de Sociedades'},
					{value: '624', text: 'Coordinados'},
					{value: '625', text: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'},
					{value: '626', text: 'Régimen Simplificado de Confianza'},
					{value: '628', text: 'Hidrocarburos'},
					{value: '629', text: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales'},
					{value: '630', text: 'Enajenación de acciones en bolsa de valores'},
				]}
			/>
		</div>
	</div>
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.email} label="Correo" placeholder="Correo electronico" required />
		</div>
	</div>
	<ZipcodeColonyComponent
		bind:zipcode={data.location.zipcode}
		bind:state={data.location.state}
		bind:city={data.location.city}
		bind:municipality={data.location.municipality}
		bind:colony={data.location.colony}
	/>
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.location.street} label="Calle" placeholder="Calle" />
		</div>
	</div>
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.location.number} label="Número" placeholder="Número" />
		</div>
		<div class="column">
			<InputText bind:value={data.location.apartment} label="Apartamento" placeholder="Apartamento" required={false} />
		</div>
	</div>
	<div class="items-end">
		<Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
	</div>
</Form>